export const Thankyou = () => (
  <section className="min-h-screen bg-[#f7f5ec] px-3 py-10">
    <div className="w-full max-w-[1320px] mx-auto text-center">
      
      {/* Logo */}
      <div className="flex justify-center cursor-pointer mb-10">
        <a href="/">
          <img
            src="/gillco-logo-original.png"
            alt="logo"
            width="180"
            height="180"
          />
        </a>
      </div>

      {/* Content */}
      <div className="space-y-6">
        
        <div>
          <span className="text-[70px] md:text-[90px] leading-[1] font-light">
            All Set..!
          </span>
        </div>

        <div>
          <span className="text-[30px] md:text-[36px] leading-[43px]">
            Thank You For Sharing Your Information
          </span>
        </div>

        <div className="max-w-2xl mx-auto">
          <span className="text-[16px] leading-[22px] text-gray-700">
            Our Team will contact with you shortly to share all the details.
          </span>
        </div>

        <div>
          <a href="/">
            <button
              className="
                inline-block
                px-9 py-4
                rounded-[30px]
                uppercase
                tracking-[0.15em]
                text-white text-sm font-semibold
                bg-[#1A6F53]
                transition-all duration-300
                hover:bg-[#053022]
                focus:outline-none
              "
            >
              Back to Home Screen
            </button>
          </a>
        </div>

      </div>
    </div>
  </section>
);